import { formatDateToYYYYMMDD } from 'utilities/dateHelper/dateHelper';

import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';

require('./profileSteps.scss');
require('./profileInvestmentPlanGBI.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const Modal = require('react-bootstrap/lib/Modal');
// @ actions
const expectedProfitabilityActions = require('actions/RAExpectedProfitability');
const formActions = require('react-redux-form').actions;
const raHireManagementPlanActions = require('actions/RAHireManagementPlan');
const raManagementPlanActions = require('actions/RAManagementPlan');
const raPortfolioDistributionActions = require('actions/RAPortfolioDistribution');
const raSuitabilityTestActions = require('actions/RASuitabilityTest');
const raSimulationActions = require('actions/RASimulation');
const stepsActions = require('actions/stepsActions');
const preLoaderActions = require('actions/preLoaderActions');
const raTimeHorizonCheckActions = require('actions/RATimeHorizonCheck');
const raCustomPlanByObjective = require('actions/RACustomPlanByObjective');
const raSetGoal = require('actions/RASetGoal');
const raExpectedProfitabilityActions = require('actions/RAExpectedProfitability');
// @ components
const Headline = require('components/headline');
const { LoadingSection } = require('commonsComponents/loadingSection');
const HighLightedText = require('components/highLightedText/highLightedText');
const { OKLink } = require('commonsComponents/OKLink');
const { OKDatePicker } = require('commonsComponents/OKDatePicker');
const { AmountInput } = require('commonsComponents/amountInput');
const RAContributionPeriodicity = require('components/RAComponents/RAContributionPeriodicity/RAContributionPeriodicity');
const RATimeHorizonCheck = require('components/RAComponents/RATimeHorizonCheck/RATimeHorizonCheck');
const RAIndexRiskModal = require('components/RAComponents/RAIndexRiskModal/RAIndexRiskModal');
const RAStrategiesGraph = require('components/RAComponents/RAStrategiesGraph/RAStrategiesGraph');
const FormattedTextWithComponents = require('components/FormattedTextWithComponents/FormattedTextWithComponents');
const RAPortfolioCompositionTable = require('components/RAComponents/RAPortfolioCompositionTable/RAPortfolioCompositionTable');
const RAPortfolioDonut = require('components/RAComponents/RAPortfolioDonut/RAPortfolioDonut');
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
const RARejected = require('components/RAComponents/RARejected/RARejected');
// @ utilities
import { FormattedText, formatText, getLanguage } from 'core/i18n';
const { getNumOfDaysBetweenDates } = require('utilities/dateHelper/dateHelper');
const { base64ToBlob, downloadAsFile } = require('utilities/APIRequestHelper');
const classNames = require('classnames');
const UtagHelper = require('utilities/utagHelper');
// @ constants
const {
    EURO_SYMBOL,
    SECOND_STEP,
    RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT,
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    CONTRIBUTION_PERIOD_MONTHLY,
    RA_PROJECTION_CHART_ALL_PRODUCTS,
    INVESTMENT_PROCESS_PDF,
} = require('constants/RAConstants');
import { PUBLICA_URL_ROOT } from 'constants/index';
import { goToErrorsView } from 'actions/errorViewNavigation';
import { ERROR_AL_ENVIAR_SIMULACION } from 'constants/analyticsErrors';
const { recordRAPage } = require('utilities/uTagging');
const {
    EVENT_ACTION_INVESTMENT_PLAN,
    INVEST_PROFILE,
    EVENT_ACTION_SHOW_PORTFOLIO_MANAGMENT_CONTRACT,
    EVENT_ACTION_SHOW_PORTFOLIO_DISTRIBUTION,
    PRODUCT_NAME_ROBO,
    SIMULATION_GBI_NAME,
    EVENT_ACTION_SHOW_RISK_INDEX,
    EVENT_ACTION_OBJECTIVE_CONFIGURATION,
    EVENT_DETAIL_RENTABILITY_DETAIL,
    EVENT_DETAIL_BUTTON_PREV,
    EVENT_DETAIL_BUTTON_NEXT,
    EVENT_CATEGORY_RA_REJECTED,
    EVENT_ACTION_RA_REJECTED,
} = require('constants/uTagConstants/RAConstants');
const { PATH_GBI_INVESTMENT_PLAN, PATH_RA_REJECTED } = require('constants/uTagConstants/paths');

class ProfileInvestmentPlanGBI extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showRiskModal: false,
            showDistributionModal: false,
        };
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const {
            raSuitabilityTestActions,
            raSimulationActions,
            preLoaderActions,
            raPortfolioDistributionActions,
            raTimeHorizonCheck,
            immCustomPlanByObjective,
            userProfile,
        } = this.props;

        const endDate = immCustomPlanByObjective.get('objectiveEndDate');
        if (endDate) {
            raTimeHorizonCheck.setTimeHorizonCheck(formatDateToYYYYMMDD(endDate));
            raTimeHorizonCheck.timeHorizonCheck(
                () => {},
                () => {}
            );
        }
        raSuitabilityTestActions.getTestResult();
        if (!immCustomPlanByObjective.get('isFetchedSimulation')) {
            preLoaderActions.showPreLoader();
            raSimulationActions.requestSimulation(false);
        }
        raPortfolioDistributionActions.requestPortfolioDistribution(userProfile.accessToken);
        raHireManagementPlanActions.getPDFContract();
    }

    componentDidUpdate(prevProps) {
        const immPrevCustomPlanByObjective = prevProps.immCustomPlanByObjective;
        const { immCustomPlanByObjective, immSetGoal, userProfile, products } = this.props;

        const keyArrayToCheck = [
            'objectiveEndDate',
            'recurringContributionAmount',
            'periodicity',
            'contributionDay',
            'objective',
            'objectiveAmount',
            'initialContributionAmount',
        ];

        const isSomeInputChanged = keyArrayToCheck.reduce(
            (acc, key) => acc || immCustomPlanByObjective.get(key) !== immPrevCustomPlanByObjective.get(key),
            false
        );

        if (isSomeInputChanged && !immCustomPlanByObjective.get('errorInitialMin')) {
            this.fetchStrategies();
        }

        if (immSetGoal.get('isFetchedGoalOnboarding') && !prevProps.immSetGoal.get('isFetchedGoalOnboarding')) {
            const investProfile = INVEST_PROFILE[immCustomPlanByObjective.get('selectedStrategy')] || '';
            const objective = immCustomPlanByObjective.get('objectiveType');

            recordRAPage(
                PATH_GBI_INVESTMENT_PLAN,
                `${PRODUCT_NAME_ROBO} ${investProfile} ${objective}`,
                userProfile.recordId,
                userProfile.userId,
                userProfile.product,
                products.get('productsDescription'),
                userProfile.promoCode ? userProfile.promoCode : '',
                false,
                '',
                '',
                userProfile.investmentType,
                ORIGIN_BY_CHANNEL[userProfile.channel]
            );
        }
    }

    onHandleInvestmentAmountChange = value => {
        const { raSetGoal, raCustomPlanByObjective } = this.props;

        raSetGoal.setInvestmentGoalValue('investmentAmount', value);
        raCustomPlanByObjective.setObjectiveAmount(value);
    };

    handleInitialContributionChange = value => {
        const { raCustomPlanByObjective } = this.props;

        raCustomPlanByObjective.setInitialContributionAmount(value);
    };

    handleRiskLinkClick = () => {
        const { userProfile } = this.props;

        this.setState({
            showRiskModal: true,
        });

        UtagHelper.recordEventRoboGBI(
            PATH_GBI_INVESTMENT_PLAN,
            SIMULATION_GBI_NAME,
            EVENT_ACTION_OBJECTIVE_CONFIGURATION,
            EVENT_ACTION_SHOW_RISK_INDEX,
            userProfile
        );
    };

    handleCloseRiskModal = () => {
        this.setState({
            showRiskModal: false,
        });
    };

    onHandleDateChange = value => {
        const { raSetGoal, raTimeHorizonCheck, raCustomPlanByObjective } = this.props;

        raSetGoal.setInvestmentGoalValue('investmentDate', value);
        raTimeHorizonCheck.setTimeHorizonCheck(formatDateToYYYYMMDD(value));
        raTimeHorizonCheck.timeHorizonCheck(
            () => {},
            () => {}
        );
        raCustomPlanByObjective.setObjectiveEndDate(value);
    };

    handleContributionDayChange = evt => {
        const { raCustomPlanByObjective, immCustomPlanByObjective } = this.props;

        const selectedDay = parseInt(evt.currentTarget.dataset.id);

        if (selectedDay !== immCustomPlanByObjective.get('recurringContributionDay')) {
            raCustomPlanByObjective.setContributionDay(selectedDay);
        }
    };

    handlePeriodicityChange = evt => {
        const { raCustomPlanByObjective } = this.props;

        raCustomPlanByObjective.setPeriodicity(evt.value);
    };

    handleRecurringContributionChange = value => {
        const { raCustomPlanByObjective } = this.props;

        const amount = value || 0;

        raCustomPlanByObjective.setRecurringContributionAmount(amount);
    };

    handleStrategyClick = value => {
        const { raCustomPlanByObjective } = this.props;

        raCustomPlanByObjective.setSelectedStrategy(value);
    };

    handlePortfolioDistributionClick = () => {
        const { userProfile } = this.props;

        this.setState({
            showDistributionModal: true,
        });

        UtagHelper.recordEventRoboGBI(
            PATH_GBI_INVESTMENT_PLAN,
            SIMULATION_GBI_NAME,
            EVENT_ACTION_OBJECTIVE_CONFIGURATION,
            EVENT_ACTION_SHOW_PORTFOLIO_DISTRIBUTION,
            userProfile
        );
    };

    handleManagementPDFClick = () => {
        const { userProfile, immHireManagementPlan } = this.props;

        const documentContent = immHireManagementPlan.get('pdfLink');
        const base64String = `data:application/pdf;base64,${documentContent}`;

        UtagHelper.recordEventRoboGBI(
            PATH_GBI_INVESTMENT_PLAN,
            SIMULATION_GBI_NAME,
            EVENT_ACTION_OBJECTIVE_CONFIGURATION,
            EVENT_ACTION_SHOW_PORTFOLIO_MANAGMENT_CONTRACT,
            userProfile
        );

        downloadAsFile(base64ToBlob(base64String), 'application/pdf', `Contrato GD.pdf`); // TBC: Filename
    };

    handleCloseDistributionModal = () => {
        this.setState({
            showDistributionModal: false,
        });
    };

    fetchStrategies = () => {
        const {
            raExpectedProfitabilityActions,
            immCustomPlanByObjective,
            userProfile: { accessToken },
        } = this.props;
        const initialContributionAmount = immCustomPlanByObjective.get('initialContributionAmount');
        const recurringContributionAmount = immCustomPlanByObjective.get('recurringContributionAmount');
        const objectiveEndDate = immCustomPlanByObjective.get('objectiveEndDate');
        const periodicity = immCustomPlanByObjective.get('periodicity');
        const contributionDay = immCustomPlanByObjective.get('contributionDay');

        if (
            initialContributionAmount == null ||
            initialContributionAmount === '' ||
            periodicity === '' ||
            recurringContributionAmount == null ||
            !objectiveEndDate
        ) {
            return;
        }

        const nDays = Math.abs(getNumOfDaysBetweenDates(objectiveEndDate));
        const chartYears = nDays / 365;
        const freq = periodicity || 1;
        if (recurringContributionAmount >= 1 && freq === CONTRIBUTION_PERIOD_MONTHLY) {
            raExpectedProfitabilityActions.requestProjectionChart(accessToken, {
                dataPoints: 2,
                chartYears,
                product: RA_PROJECTION_CHART_ALL_PRODUCTS,
                balance: initialContributionAmount,
                freq,
                mntPayment: recurringContributionAmount,
                cutDay: contributionDay,
            });
        } else {
            raExpectedProfitabilityActions.requestProjectionChart(accessToken, {
                dataPoints: 2,
                chartYears,
                product: RA_PROJECTION_CHART_ALL_PRODUCTS,
                balance: initialContributionAmount,
                freq,
                mntPayment: recurringContributionAmount,
            });
        }
    };

    gotoNextStep = () => {
        const { userProfile, actions, immStepsState, immCustomPlanByObjective } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.get('readOnlyForms');
        const value = immCustomPlanByObjective.get('selectedStrategy');

        UtagHelper.recordEventRoboGBI(
            PATH_GBI_INVESTMENT_PLAN,
            SIMULATION_GBI_NAME,
            EVENT_ACTION_INVESTMENT_PLAN,
            INVEST_PROFILE[value],
            userProfile
        );

        if (!disabled) {
            actions.finalizeStep({
                index: currentIndex,
                finished: true,
            });
            actions.enableFinishedAndNextStep();
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        } else {
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }
    };

    handlePrevStep = () => {
        const { immStepsState, actions } = this.props;
        const currentStep = immStepsState.get('currentStep');

        actions.changeCurrentStep({
            index: parseInt(currentStep) - 1,
        });
    };

    onContinue = () => {
        const {
            immStepsState,
            raSimulationActions,
            preLoaderActions,
            userProfile: { accessToken },
        } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const currentStep = immStepsState.getIn(['steps', currentIndex]);

        if (currentStep.get('finished')) {
            this.gotoNextStep();
        } else {
            preLoaderActions.showPreLoader();
            raSimulationActions.saveSimulation(
                accessToken,
                () => {
                    this.deleteGoalOnboarding();
                    this.sendOkSimulation();
                },
                true
            );
        }
    };

    sendOkSimulation = () => {
        const { userProfile, preLoaderActions, raSimulationActions, goToErrorsView } = this.props;
        raSimulationActions.sendOkSimulation(userProfile.accessToken, verifiedOk => {
            preLoaderActions.hidePreLoader();
            if (verifiedOk) {
                this.gotoNextStep();
            } else {
                goToErrorsView({ errorMessage: ERROR_AL_ENVIAR_SIMULACION });
                this.setState({ isClicked: false });
            }
        });
    };

    deleteGoalOnboarding = () => {
        const { raSetGoal, userProfile } = this.props;

        raSetGoal.deleteGoalOnboarding(userProfile.accessToken);
    };

    buildRiskModal = () => {
        let modal = null;

        if (this.state.showRiskModal) {
            modal = (
                <RAIndexRiskModal
                    show={this.state.showRiskModal}
                    onModalClose={this.handleCloseRiskModal}
                    userProfile={this.props.userProfile}
                />
            );
        }

        return modal;
    };

    buildInitialInvestmentSection = () => {
        const { immCustomPlanByObjective, immStepsState } = this.props;

        const calendar = this.buildCustomCalender();
        const injectedStrings = [MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT];
        const investmentAmount = immCustomPlanByObjective.get('objectiveAmount');
        const initialInvestment = immCustomPlanByObjective.get('initialContributionAmount');
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.getIn(['steps', currentIndex, 'finished']);

        return (
            <div className="investment-plan-gbi__objective-amount-section">
                <div className="investment-plan-gbi__goal-amount">
                    <div className="investment-plan-gbi__goal-amount__title">
                        {formatText('raSetGoal-goalAmountTitle')}
                    </div>
                    <div className="investment-plan-gbi__goal-amount__input-wrapper">
                        <AmountInput
                            amount={investmentAmount}
                            callback={this.onHandleInvestmentAmountChange}
                            error={immCustomPlanByObjective.get('errorAmount')}
                            errorMsg={formatText('raInput-amountInputMinimumValidation', injectedStrings)}
                            hideFocusZero={true}
                            language={getLanguage()}
                            max={RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT}
                            name={name}
                            disabled={disabled}
                        />
                    </div>
                    <span className="investment-plan-gbi__goal-amount__input-symbol">{EURO_SYMBOL}</span>
                </div>
                {calendar}
                <div className="investment-plan-gbi__initial-amount">
                    <div className="investment-plan-gbi__initial-amount__title">
                        {formatText('investmentPlan-amount')}
                    </div>
                    <div className="investment-plan-gbi__initial-amount__input-wrapper">
                        <AmountInput
                            amount={initialInvestment}
                            callback={this.handleInitialContributionChange} // eslint-disable-line
                            error={immCustomPlanByObjective.get('errorInitialMin')}
                            errorMsg={formatText('raInput-amountInputMinimumValidation', [
                                MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
                            ])}
                            fluid={true}
                            hideFocusZero={true}
                            instructionsMessage={formatText('investmentPlan-instructionInitialInvestment')}
                            keepZeroAndEmpty={true}
                            language={getLanguage()}
                            max={MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT}
                            showBlurZero={false}
                            disabled={disabled}
                        />
                    </div>
                    <span className="investment-plan-gbi__initial-amount__input-symbol">{EURO_SYMBOL}</span>
                </div>
            </div>
        );
    };

    buildCustomCalender = () => {
        const { immSetGoal, immCustomPlanByObjective, immStepsState } = this.props;
        const investmentDate = new Date(immCustomPlanByObjective.get('objectiveEndDate'));
        const dateLabel = formatText('raSetGoal-calenderText');
        const minDate = immSetGoal.getIn(['steps', SECOND_STEP, 'minDate']);
        const maxDate = immSetGoal.getIn(['steps', SECOND_STEP, 'maxDate']);
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.getIn(['steps', currentIndex, 'finished']);

        return (
            <div className="investment-plan-gbi__end-date-section">
                <div className="investment-plan-gbi__end-date-section__title">{dateLabel}</div>
                <div className="investment-plan-gbi__end-date-section__input-wrapper">
                    <OKDatePicker
                        callback={this.onHandleDateChange}
                        dateFormat={formatText('datePickerCustom-dateFormat')}
                        startDate={minDate}
                        maxDate={maxDate}
                        minDate={minDate}
                        placeholder={formatText('datePickerCustom-placeholder')}
                        selectedDate={investmentDate}
                        newSelectedDate={investmentDate}
                        messageStandardErrorDate={formatText('raSetGoal-dateError')}
                        messageLessThanMinDateError={formatText('raSetGoal-minDateError')}
                        messageMoreThanMinDateError={formatText('raSetGoal-maxDateError')}
                        disabled={disabled}
                    />
                </div>
            </div>
        );
    };

    buildContributionPeriodicity = () => {
        const { immCustomPlanByObjective, immStepsState } = this.props;
        const contributionAmount = immCustomPlanByObjective.get('recurringContributionAmount');
        const periodicity = immCustomPlanByObjective.get('periodicity');
        const contributionDay = immCustomPlanByObjective.get('recurringContributionDay');
        const disableSelect = contributionAmount < 1;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.getIn(['steps', currentIndex, 'finished']);

        let content = null;

        content = (
            <div className="investment-plan-gbi__contribution-periodicity">
                <div className="investment-plan-gbi__contribution-periodicity__title-wrapper">
                    <span className="investment-plan-gbi__contribution-periodicity__title">
                        <FormattedText value="investmentPlan-contributionPrimaryInfo" />
                    </span>
                    <span className="investment-plan-gbi__contribution-periodicity__subtitle">
                        <FormattedText value="investmentPlan-contributionSecondaryInfo" />
                    </span>
                </div>
                <div className="investment-plan-gbi__contribution-periodicity__info-wrapper">
                    <div className="investment-plan-gbi__contribution-periodicity__info">
                        <FormattedText value="investmentPlan-contributionTitle" />
                    </div>
                </div>
                <RAContributionPeriodicity
                    amount={contributionAmount}
                    disableSelect={disableSelect}
                    errorMessage={formatText('investmentPlan-contributionErrorMessage')}
                    errorState={immCustomPlanByObjective.get('errorPeriodicityMin')}
                    hideFocusZero={true}
                    keepZeroAndEmpty={true}
                    onDayClick={this.handleContributionDayChange}
                    onPeriodicityChange={this.handlePeriodicityChange}
                    onRecurringContributionChange={this.handleRecurringContributionChange}
                    selectedDay={contributionDay}
                    selectedPeriodicity={periodicity}
                    disabled={disabled}
                />
            </div>
        );

        return content;
    };

    getInvestProfileValue = () => {
        const { immCustomPlanByObjective, immTimeHorizonCheck } = this.props;
        const maxInvestProfileValue = immTimeHorizonCheck.get('maxTypeOfProduct');
        const candidateProfileValue = immCustomPlanByObjective.get('selectedStrategy');

        return maxInvestProfileValue >= candidateProfileValue ? candidateProfileValue : null;
    };

    buildStrategyGraph = () => {
        const {
            immCustomPlanByObjective,
            immTimeHorizonCheck,
            immExpectedProfitability,
            immSuitabilityTest,
            immStepsState,
        } = this.props;
        const maxInvestmentProfile = immSuitabilityTest.getIn(['results', 0, 'maxTypeOfProduct'], 0);
        const maxAvailableInvestmentProfile = immTimeHorizonCheck.get('maxTypeOfProduct');
        const objectiveEndDate = immCustomPlanByObjective.get('objectiveEndDate');
        const initialContributionAmount = immCustomPlanByObjective.get('initialContributionAmount');
        const goal = immCustomPlanByObjective.get('objectiveAmount');
        const recurringContributionAmount = immCustomPlanByObjective.get('recurringContributionAmount');
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.getIn(['steps', currentIndex, 'finished']);

        let strategyContent = <LoadingSection />;

        if (!immCustomPlanByObjective.get('isFetchingProfile')) {
            const investProfileValue = this.getInvestProfileValue();

            strategyContent = (
                <div>
                    <RAStrategiesGraph
                        goal={goal}
                        immExpectedProfitability={immExpectedProfitability}
                        initialContributionAmount={initialContributionAmount}
                        objectiveEndDate={objectiveEndDate}
                        recurringContributionAmount={recurringContributionAmount}
                        onStrategyClick={this.handleStrategyClick}
                        maxAvailableInvestmentProfile={maxAvailableInvestmentProfile}
                        maxInvestmentProfile={maxInvestmentProfile}
                        selectedStrategy={investProfileValue}
                        showDescription={true}
                        singleStrategy={false}
                        sourceUrl="goal"
                        onPortfolioDistributionClick={this.handlePortfolioDistributionClick}
                        disabled={disabled}
                    />
                </div>
            );
        }

        return strategyContent;
    };

    buildDistributionModal = () => {
        const { immCustomPlanByObjective, immPortfolioDistribution } = this.props;

        let modal,
            donutContent,
            tableContent = null;

        if (!immCustomPlanByObjective.get('isFetchingProfile')) {
            const investProfileValue = this.getInvestProfileValue();
            if (investProfileValue > 0) {
                const immAssetAllocations = immPortfolioDistribution.getIn(
                    ['portfolio', investProfileValue.toString(), 'assetAllocations'],
                    []
                );
                const strategyName = classNames(`raPortfolioDistribution-strategy${investProfileValue}`);
                const strategyIcon = classNames(
                    'icons',
                    'icons--icon-strategy-small',
                    `icons--icon-strategy-small--${investProfileValue}`,
                    'ra-portfolio-distribution-modal__strategy-icon'
                );

                if (immPortfolioDistribution.get('isFetching')) {
                    donutContent = <LoadingSection />;
                    tableContent = <LoadingSection />;
                } else if (immAssetAllocations) {
                    donutContent = <RAPortfolioDonut immAssetAllocations={immAssetAllocations} />;
                    tableContent = (
                        <RAPortfolioCompositionTable
                            immAssetAllocations={immAssetAllocations}
                            immManagementPlan={immCustomPlanByObjective}
                        />
                    );
                }

                const show = this.state.showDistributionModal;

                modal = (
                    <Modal
                        show={show}
                        onHide={this.handleCloseDistributionModal}
                        className="ra-portfolio-distribution-modal"
                        dialogClassName="ra-portfolio-distribution-modal"
                        backdrop="static"
                        animation={true}
                    >
                        <Modal.Header>
                            <div className="close-icon">
                                <a
                                    href="#"
                                    onClick={event => {
                                        event.preventDefault();
                                        this.handleCloseDistributionModal();
                                    }}
                                >
                                    <i className="icons icons--icon-close" />
                                </a>
                            </div>
                            <div className="title">
                                <div className="title__icon">
                                    <i className={strategyIcon} />
                                </div>
                                <div className="title__text">
                                    <FormattedText value={strategyName} />
                                </div>
                            </div>
                            <hr className="visible-xs" />
                        </Modal.Header>
                        <Modal.Body>
                            <div className="investment-plan-gbi__distribution">
                                <div className="investment-plan-gbi__distribution-title">
                                    {formatText('investmentPlan-distributionTitle')}
                                </div>
                                <div className="investment-plan__section-info investment-plan-gbi__distribution-info hidden-xs">
                                    <FormattedText value="investmentPlan-distributionInfo" />
                                </div>
                                {donutContent}
                                <div className="investment-plan-gbi__distribution-details-title">
                                    {formatText('investmentPlan-distributionDetailsTitle')}
                                </div>
                                {tableContent}
                            </div>
                        </Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                );
            }
        }

        return modal;
    };

    buildMoreDetailSection = () => {
        const { userProfile } = this.props;
        const publicUrl = typeof PUBLICA_URL_ROOT !== 'undefined' && PUBLICA_URL_ROOT !== null ? PUBLICA_URL_ROOT : '';
        const moreInfoLinkURL = `${publicUrl}${INVESTMENT_PROCESS_PDF}`;
        const moreInfoLink = (
            <OKLink
                modifier="emphasize"
                to={moreInfoLinkURL}
                target="_blank"
                onClick={() => {
                    UtagHelper.recordEventRoboGBI(
                        PATH_GBI_INVESTMENT_PLAN,
                        SIMULATION_GBI_NAME,
                        EVENT_ACTION_INVESTMENT_PLAN,
                        EVENT_DETAIL_RENTABILITY_DETAIL,
                        userProfile
                    );
                }}
            >
                <span>
                    <i className="icon-document" />
                    <FormattedText value="investmentPlan-moreInfoLink" />
                </span>
            </OKLink>
        );
        const moreInfoLinkManagement = (
            <OKLink modifier="emphasize" onClick={this.handleManagementPDFClick}>
                <FormattedText value="investmentPlan-moreInfoText3Link" />
            </OKLink>
        );

        return (
            <div className="investment-plan__more-info-link investment-plan-gbi__more-info-link">
                <p>
                    <FormattedTextWithComponents
                        value="investmentPlan-moreInfoText"
                        injectedComponents={[moreInfoLink]}
                    />
                    <FormattedTextWithComponents
                        value="investmentPlan-moreInfoText3"
                        injectedComponents={[moreInfoLinkManagement]}
                    />
                </p>
            </div>
        );
    };

    buildProfileInvestmentPlan = () => {
        const { immSuitabilityTest, immCustomPlanByObjective, immStepsState } = this.props;
        const showPortfolioSection =
            immCustomPlanByObjective.get('objectiveAmount') &&
            immCustomPlanByObjective.get('initialContributionAmount') &&
            immCustomPlanByObjective.get('objectiveEndDate') &&
            !immCustomPlanByObjective.get('errorInitialMin');
        const investProfileDescription = immSuitabilityTest.getIn(['results', 0, 'clientRiskProfileTitle'], '');
        const initalInvestmentSection = this.buildInitialInvestmentSection();
        const contributionPeriodicity = this.buildContributionPeriodicity();
        const strategyContent = this.buildStrategyGraph();
        const riskModal = this.buildRiskModal();
        const distributionModal = this.buildDistributionModal();
        const moreInfoSection = this.buildMoreDetailSection();
        const portfolioSectionClass = classNames('investment-plan-gbi__portfolio-section', {
            hidden: !showPortfolioSection,
        });
        const disabled = this.isContinueButtonDisabled();
        const disabledInvestmentPlan = immStepsState.getIn(['steps', 4, 'finished']);
        const investContainerClass = classNames('investment-plan-gbi__investment-plan', {
            'investment-plan-gbi__investment-plan--disabled': disabledInvestmentPlan,
        });

        return (
            <div className="prospects-step-content basic-layering">
                {riskModal}
                {distributionModal}
                <Headline icon="holders" className="prospects-gutter">
                    <h2>
                        <FormattedText value="raSetGoal-headerTitle" />
                    </h2>
                </Headline>
                <div className="investment-plan-gbi__header">
                    <div className="investment-plan-gbi__header-profile-label">
                        <FormattedText value="investmentPlan-inversorProfile" />
                    </div>
                    <div className="investment-plan-gbi__header-profile-type">{investProfileDescription}</div>
                    <div className="investment-plan-gbi__header-description">
                        <FormattedText value="investmentPlan-headerDescription" />
                    </div>
                </div>
                <hr />
                <div className={investContainerClass}>
                    {initalInvestmentSection}
                    {contributionPeriodicity}
                    <RATimeHorizonCheck />
                </div>
                <div className={portfolioSectionClass}>
                    <div className="investment-plan__section-header">
                        <div className="investment-plan__inversion-profile-title">
                            <FormattedText value="investmentPlan-investProfileTitle" />
                        </div>
                    </div>
                    <div className="investment-plan__inversion-profile-subtitle">
                        <FormattedText value="investmentPlan-investProfileSubtitle" />
                    </div>
                    <div className="investment-plan__section-button">
                        <button className="investment-plan__risk-index-button" onClick={this.handleRiskLinkClick}>
                            <FormattedText value="investmentPlan-riskIndexButtonLabel" />
                            <i className="investment-plan__risk-index-icon icon-flag-tracking" />
                        </button>
                    </div>
                    <div className="investment-plan__expected-profitability-section">
                        {strategyContent}
                        {moreInfoSection}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="investment-plan__info-container investment-plan-gbi__info-container">
                            <HighLightedText
                                className="form__hightlight-text form__hightlight-text--disclaimer"
                                icon={<i className="icons icons--icon-info-blue" />}
                            >
                                <FormattedText value="investmentPlan-disclaimerInfo" />
                            </HighLightedText>
                        </div>
                    </div>
                </div>
                <div className="row form__footer">
                    <RoadmapNavigation buttonContinueAction={this.onContinue} buttonContinueDisabled={disabled} />
                </div>
            </div>
        );
    };

    isContinueButtonDisabled = () => {
        const { immCustomPlanByObjective, immTimeHorizonCheck } = this.props;

        return !(
            immCustomPlanByObjective.get('objectiveAmount') &&
            immCustomPlanByObjective.get('initialContributionAmount') &&
            immCustomPlanByObjective.get('objectiveEndDate') &&
            !immCustomPlanByObjective.get('errorInitialMin') &&
            immCustomPlanByObjective.get('selectedStrategy') &&
            !immTimeHorizonCheck.get('ipModification')
        );
    };

    render() {
        const { userProfile } = this.props;
        let content = <LoadingSection />;

        if (userProfile.withoutGbi) {
            content = (
                <RARejected
                    title={formatText('raSuitabilityTest-gbiRejectedTitle')}
                    subtitle={formatText('raSuitabilityTest-gbiRejectedSubtitle')}
                    onContinueAction={() => {
                        UtagHelper.recordEventRoboGBI(
                            PATH_RA_REJECTED,
                            EVENT_CATEGORY_RA_REJECTED,
                            EVENT_ACTION_RA_REJECTED,
                            EVENT_DETAIL_BUTTON_NEXT,
                            userProfile
                        );
                        this.gotoNextStep();
                    }}
                    onPrevAction={() => {
                        UtagHelper.recordEventRoboGBI(
                            PATH_RA_REJECTED,
                            EVENT_CATEGORY_RA_REJECTED,
                            EVENT_ACTION_RA_REJECTED,
                            EVENT_DETAIL_BUTTON_PREV,
                            userProfile
                        );
                        this.handlePrevStep();
                    }}
                />
            );
        } else {
            content = this.buildProfileInvestmentPlan();
        }

        return content;
    }
}

module.exports.constructor = ProfileInvestmentPlanGBI;
module.exports.ProfileInvestmentPlanGBI = connect(
    state => ({
        immSetGoal: state.raSetGoal,
        immExpectedProfitability: state.raExpectedProfitability,
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        immHireManagementPlan: state.raHireManagementPlan,
        immManagementPlan: state.raManagementPlan,
        immPortfolioDistribution: state.raPortfolioDistribution,
        immStepsState: state.steps,
        immSuitabilityTest: state.raSuitabilityTest,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
        immSimulation: state.raSimulation,
        userProfile: state.userProfile,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        expectedProfitabilityActions: bindActionCreators(expectedProfitabilityActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        raHireManagementPlanActions: bindActionCreators(raHireManagementPlanActions, dispatch),
        raManagementPlanActions: bindActionCreators(raManagementPlanActions, dispatch),
        raPortfolioDistributionActions: bindActionCreators(raPortfolioDistributionActions, dispatch),
        raSuitabilityTestActions: bindActionCreators(raSuitabilityTestActions, dispatch),
        raSimulationActions: bindActionCreators(raSimulationActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        raTimeHorizonCheck: bindActionCreators(raTimeHorizonCheckActions, dispatch),
        raCustomPlanByObjective: bindActionCreators(raCustomPlanByObjective, dispatch),
        raSetGoal: bindActionCreators(raSetGoal, dispatch),
        raExpectedProfitabilityActions: bindActionCreators(raExpectedProfitabilityActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(ProfileInvestmentPlanGBI);
